import { Container, Typography } from "@mui/material";

import { ResponseTime } from "../types/types";
import ResponseTimeChart from "./charts/ResponseTimeChart";

type ResponseTimeReportProps = {
  data: ResponseTime;
  location: string;
};
const ResponseTimeReport = (props: ResponseTimeReportProps) => {
  return (
    <Container>
      <ResponseTimeChart data={props.data} location={props.location} />
    </Container>
  );
};

export default ResponseTimeReport;
